import * as React from "react";
import classnames from "classnames";
import { useFormContext, CheckboxView } from "@grandvisionhq/forms";
const ControlledCheckbox = ({
  id,
  name,
  className,
  label,
  value,
  "data-t": dataT,
  "aria-label": ariaLabel,
  onChange: onChangeProp,
  required,
  ...rest
}) => {
  const formContext = useFormContext();
  const onChange = React.useCallback(
    ({ checked }) => {
      onChangeProp && onChangeProp(checked ? "true" : "");
    },
    [onChangeProp]
  );
  const { isTouched, isValid } = formContext.getInitialState?.(id) ?? {};
  return /* @__PURE__ */ React.createElement(
    CheckboxView,
    {
      ...rest,
      "data-t": dataT,
      id,
      name,
      className: classnames("controlled-checkbox", className),
      label,
      "aria-label": ariaLabel,
      value: value ?? "",
      checked: value === "true",
      error: isTouched && isValid === false,
      errorId: `${id}_error`,
      required,
      onChange
    }
  );
};
export {
  ControlledCheckbox as default
};
//# sourceMappingURL=ControlledCheckbox.js.map
